import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { of, throwError } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

import { ICustomer } from '../models/customer.model';
import { CurrentDataService } from '../services/current-data-service';

export const currentCustomerResolve: ResolveFn<ICustomer> = () => {
  const currentDataService = inject(CurrentDataService);

  return currentDataService.getCustomer().pipe(mergeMap(customer => (customer ? of(customer) : throwError(() => new Error('No customer!')))));
};
